import { getCurrentInstance } from 'vue';

export default function useToast() {
  const vm = getCurrentInstance();
  console.log(vm?.proxy?.$refs);
  return vm?.proxy?.$refs.toastRef;
}
